
const reducer = (state,action) => {
    switch(action.type){
      case "ADD_TO_CART":{
        return [...state,action.payload]
      }
      case "REMOVE_FROM_CART":{
        const cartAfertRemove = state.filter((item)=>{
           return item.id !== action.payload
        })
        return cartAfertRemove
      }
      case "CHECKOUT":{
        return []
      }
      default:{
        return state
      }
    }
  
}

export default reducer